import { useEffect, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';

import { matrixSelector, dataLayerPayloadSelector } from '../slices/matrixSlice';
import useDataLayer from '../../../utils/useDataLayer';

const Tracking = forwardRef((props, ref) => {
  const [pushEvent] = useDataLayer();
  const {
    selectionSku,
    startTracking,
    pageOptions,
    prices: { selection_price: { gross: { price } } }
  } = useSelector(matrixSelector);
  // When changing the roll options the selection sku will not change,
  // that's why we have to add another trigger to the bellow useEffect
  // with the extracted the roll options values
  const rollOptionsChange = pageOptions.filter(({ id }) => id === 'model' || id === 'refinement').map(option => option.selection_id).join('_');
  const dataLayerPayload = useSelector(dataLayerPayloadSelector);

  useImperativeHandle(ref, () => ({
    trackFinishConfigurator() {
      pushConfiguratorFinish();
    },
    trackStartDesigning() {
      pushConfiguratorEvent({
        event: 'startDesigningPopupDisplayed'
      });
    },
    trackStartDesigningCta(startDesigningAction) {
      pushConfiguratorEvent({
        event: 'startDesigningCTA',
        startDesigningAction
      });
    }
  }));

  const pushConfiguratorEvent = (payload) => {
    pushEvent(payload);
  };
  const pushConfiguratorUpdate = () => {
    pushConfiguratorEvent({
      event: 'productConfiguratorUpdate',
      ...dataLayerPayload
    });
  };

  const pushConfiguratorFinish = () => {
    pushConfiguratorEvent({
      event: 'productConfiguratorComplete',
      ...dataLayerPayload
    });
  };

  useEffect(() => {
    if (startTracking) {
      pushConfiguratorUpdate();
    }
  }, [selectionSku, price, rollOptionsChange]);

  return null;
});

export default Tracking;
